"use client";

import _defineProperty from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { createDialogComponent, useDialog } from "./JC64G2H7.js";
import { PopoverScopedContextProvider, usePopoverProviderContext } from "./MTZPJQMC.js";
import { createElement, createHook, forwardRef } from "./LMDWO4NN.js";
import { useEvent, usePortalRef, useSafeLayoutEffect, useWrapElement } from "./ABQUS43J.js";
import { __objRest, __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/popover/popover.tsx
import { invariant } from "@ariakit/core/utils/misc";
import { arrow, autoUpdate, computePosition, flip, limitShift, offset, shift, size } from "@floating-ui/dom";
import { useRef, useState } from "react";
import { jsx } from "react/jsx-runtime";
var TagName = "div";
function createDOMRect() {
  var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  if (typeof DOMRect === "function") {
    return new DOMRect(x, y, width, height);
  }
  var rect = {
    x: x,
    y: y,
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x
  };
  return __spreadProps(__spreadValues({}, rect), {
    toJSON: function toJSON() {
      return rect;
    }
  });
}
function getDOMRect(anchorRect) {
  if (!anchorRect) return createDOMRect();
  var x = anchorRect.x,
    y = anchorRect.y,
    width = anchorRect.width,
    height = anchorRect.height;
  return createDOMRect(x, y, width, height);
}
function getAnchorElement(anchorElement, getAnchorRect) {
  var contextElement = anchorElement || void 0;
  return {
    contextElement: contextElement,
    getBoundingClientRect: function getBoundingClientRect() {
      var anchor = anchorElement;
      var anchorRect = getAnchorRect == null ? void 0 : getAnchorRect(anchor);
      if (anchorRect || !anchor) {
        return getDOMRect(anchorRect);
      }
      return anchor.getBoundingClientRect();
    }
  };
}
function isValidPlacement(flip2) {
  return /^(?:top|bottom|left|right)(?:-(?:start|end))?$/.test(flip2);
}
function roundByDPR(value) {
  var dpr = window.devicePixelRatio || 1;
  return Math.round(value * dpr) / dpr;
}
function getOffsetMiddleware(arrowElement, props) {
  return offset(function (_ref) {
    var placement = _ref.placement;
    var _a;
    var arrowOffset = ((arrowElement == null ? void 0 : arrowElement.clientHeight) || 0) / 2;
    var finalGutter = typeof props.gutter === "number" ? props.gutter + arrowOffset : (_a = props.gutter) != null ? _a : arrowOffset;
    var hasAlignment = !!placement.split("-")[1];
    return {
      crossAxis: !hasAlignment ? props.shift : void 0,
      mainAxis: finalGutter,
      alignmentAxis: props.shift
    };
  });
}
function getFlipMiddleware(props) {
  if (props.flip === false) return;
  var fallbackPlacements = typeof props.flip === "string" ? props.flip.split(" ") : void 0;
  invariant(!fallbackPlacements || fallbackPlacements.every(isValidPlacement), process.env.NODE_ENV !== "production" && "`flip` expects a spaced-delimited list of placements");
  return flip({
    padding: props.overflowPadding,
    fallbackPlacements: fallbackPlacements
  });
}
function getShiftMiddleware(props) {
  if (!props.slide && !props.overlap) return;
  return shift({
    mainAxis: props.slide,
    crossAxis: props.overlap,
    padding: props.overflowPadding,
    limiter: limitShift()
  });
}
function getSizeMiddleware(props) {
  return size({
    padding: props.overflowPadding,
    apply: function apply(_ref2) {
      var elements = _ref2.elements,
        availableWidth = _ref2.availableWidth,
        availableHeight = _ref2.availableHeight,
        rects = _ref2.rects;
      var wrapper = elements.floating;
      var referenceWidth = Math.round(rects.reference.width);
      availableWidth = Math.floor(availableWidth);
      availableHeight = Math.floor(availableHeight);
      wrapper.style.setProperty("--popover-anchor-width", "".concat(referenceWidth, "px"));
      wrapper.style.setProperty("--popover-available-width", "".concat(availableWidth, "px"));
      wrapper.style.setProperty("--popover-available-height", "".concat(availableHeight, "px"));
      if (props.sameWidth) {
        wrapper.style.width = "".concat(referenceWidth, "px");
      }
      if (props.fitViewport) {
        wrapper.style.maxWidth = "".concat(availableWidth, "px");
        wrapper.style.maxHeight = "".concat(availableHeight, "px");
      }
    }
  });
}
function getArrowMiddleware(arrowElement, props) {
  if (!arrowElement) return;
  return arrow({
    element: arrowElement,
    padding: props.arrowPadding
  });
}
var usePopover = createHook(function usePopover2(_a) {
  var _b = _a,
    store = _b.store,
    _b$modal = _b.modal,
    modal = _b$modal === void 0 ? false : _b$modal,
    _b$portal = _b.portal,
    portal = _b$portal === void 0 ? !!modal : _b$portal,
    _b$preserveTabOrder = _b.preserveTabOrder,
    preserveTabOrder = _b$preserveTabOrder === void 0 ? true : _b$preserveTabOrder,
    _b$autoFocusOnShow = _b.autoFocusOnShow,
    autoFocusOnShow = _b$autoFocusOnShow === void 0 ? true : _b$autoFocusOnShow,
    wrapperProps = _b.wrapperProps,
    _b$fixed = _b.fixed,
    fixed = _b$fixed === void 0 ? false : _b$fixed,
    _b$flip = _b.flip,
    flip2 = _b$flip === void 0 ? true : _b$flip,
    _b$shift = _b.shift,
    shift2 = _b$shift === void 0 ? 0 : _b$shift,
    _b$slide = _b.slide,
    slide = _b$slide === void 0 ? true : _b$slide,
    _b$overlap = _b.overlap,
    overlap = _b$overlap === void 0 ? false : _b$overlap,
    _b$sameWidth = _b.sameWidth,
    sameWidth = _b$sameWidth === void 0 ? false : _b$sameWidth,
    _b$fitViewport = _b.fitViewport,
    fitViewport = _b$fitViewport === void 0 ? false : _b$fitViewport,
    gutter = _b.gutter,
    _b$arrowPadding = _b.arrowPadding,
    arrowPadding = _b$arrowPadding === void 0 ? 4 : _b$arrowPadding,
    _b$overflowPadding = _b.overflowPadding,
    overflowPadding = _b$overflowPadding === void 0 ? 8 : _b$overflowPadding,
    getAnchorRect = _b.getAnchorRect,
    updatePosition = _b.updatePosition,
    props = __objRest(_b, ["store", "modal", "portal", "preserveTabOrder", "autoFocusOnShow", "wrapperProps", "fixed", "flip", "shift", "slide", "overlap", "sameWidth", "fitViewport", "gutter", "arrowPadding", "overflowPadding", "getAnchorRect", "updatePosition"]);
  var context = usePopoverProviderContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "Popover must receive a `store` prop or be wrapped in a PopoverProvider component.");
  var arrowElement = store.useState("arrowElement");
  var anchorElement = store.useState("anchorElement");
  var disclosureElement = store.useState("disclosureElement");
  var popoverElement = store.useState("popoverElement");
  var contentElement = store.useState("contentElement");
  var placement = store.useState("placement");
  var mounted = store.useState("mounted");
  var rendered = store.useState("rendered");
  var defaultArrowElementRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    positioned = _useState2[0],
    setPositioned = _useState2[1];
  var _usePortalRef = usePortalRef(portal, props.portalRef),
    portalRef = _usePortalRef.portalRef,
    domReady = _usePortalRef.domReady;
  var getAnchorRectProp = useEvent(getAnchorRect);
  var updatePositionProp = useEvent(updatePosition);
  var hasCustomUpdatePosition = !!updatePosition;
  useSafeLayoutEffect(function () {
    if (!(popoverElement == null ? void 0 : popoverElement.isConnected)) return;
    popoverElement.style.setProperty("--popover-overflow-padding", "".concat(overflowPadding, "px"));
    var anchor = getAnchorElement(anchorElement, getAnchorRectProp);
    var updatePosition2 = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var arrow2, middleware, pos, x, y, _pos$middlewareData$a, arrowX, arrowY, side, centerX, centerY, originX, originY;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (mounted) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!arrowElement) {
                defaultArrowElementRef.current = defaultArrowElementRef.current || document.createElement("div");
              }
              arrow2 = arrowElement || defaultArrowElementRef.current;
              middleware = [getOffsetMiddleware(arrow2, {
                gutter: gutter,
                shift: shift2
              }), getFlipMiddleware({
                flip: flip2,
                overflowPadding: overflowPadding
              }), getShiftMiddleware({
                slide: slide,
                shift: shift2,
                overlap: overlap,
                overflowPadding: overflowPadding
              }), getArrowMiddleware(arrow2, {
                arrowPadding: arrowPadding
              }), getSizeMiddleware({
                sameWidth: sameWidth,
                fitViewport: fitViewport,
                overflowPadding: overflowPadding
              })];
              _context.next = 7;
              return computePosition(anchor, popoverElement, {
                placement: placement,
                strategy: fixed ? "fixed" : "absolute",
                middleware: middleware
              });
            case 7:
              pos = _context.sent;
              store == null ? void 0 : store.setState("currentPlacement", pos.placement);
              setPositioned(true);
              x = roundByDPR(pos.x);
              y = roundByDPR(pos.y);
              Object.assign(popoverElement.style, {
                top: "0",
                left: "0",
                transform: "translate3d(".concat(x, "px,").concat(y, "px,0)")
              });
              if (arrow2 && pos.middlewareData.arrow) {
                _pos$middlewareData$a = pos.middlewareData.arrow, arrowX = _pos$middlewareData$a.x, arrowY = _pos$middlewareData$a.y;
                side = pos.placement.split("-")[0];
                centerX = arrow2.clientWidth / 2;
                centerY = arrow2.clientHeight / 2;
                originX = arrowX != null ? arrowX + centerX : -centerX;
                originY = arrowY != null ? arrowY + centerY : -centerY;
                popoverElement.style.setProperty("--popover-transform-origin", {
                  top: "".concat(originX, "px calc(100% + ").concat(centerY, "px)"),
                  bottom: "".concat(originX, "px ").concat(-centerY, "px"),
                  left: "calc(100% + ".concat(centerX, "px) ").concat(originY, "px"),
                  right: "".concat(-centerX, "px ").concat(originY, "px")
                }[side]);
                Object.assign(arrow2.style, _defineProperty({
                  left: arrowX != null ? "".concat(arrowX, "px") : "",
                  top: arrowY != null ? "".concat(arrowY, "px") : ""
                }, side, "100%"));
              }
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function updatePosition2() {
        return _ref3.apply(this, arguments);
      };
    }();
    var update = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!hasCustomUpdatePosition) {
                _context2.next = 6;
                break;
              }
              _context2.next = 3;
              return updatePositionProp({
                updatePosition: updatePosition2
              });
            case 3:
              setPositioned(true);
              _context2.next = 8;
              break;
            case 6:
              _context2.next = 8;
              return updatePosition2();
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function update() {
        return _ref4.apply(this, arguments);
      };
    }();
    var cancelAutoUpdate = autoUpdate(anchor, popoverElement, update, {
      // JSDOM doesn't support ResizeObserver
      elementResize: typeof ResizeObserver === "function"
    });
    return function () {
      setPositioned(false);
      cancelAutoUpdate();
    };
  }, [store, rendered, popoverElement, arrowElement, anchorElement, popoverElement, placement, mounted, domReady, fixed, flip2, shift2, slide, overlap, sameWidth, fitViewport, gutter, arrowPadding, overflowPadding, getAnchorRectProp, hasCustomUpdatePosition, updatePositionProp]);
  useSafeLayoutEffect(function () {
    if (!mounted) return;
    if (!domReady) return;
    if (!(popoverElement == null ? void 0 : popoverElement.isConnected)) return;
    if (!(contentElement == null ? void 0 : contentElement.isConnected)) return;
    var applyZIndex = function applyZIndex() {
      popoverElement.style.zIndex = getComputedStyle(contentElement).zIndex;
    };
    applyZIndex();
    var raf = requestAnimationFrame(function () {
      raf = requestAnimationFrame(applyZIndex);
    });
    return function () {
      return cancelAnimationFrame(raf);
    };
  }, [mounted, domReady, popoverElement, contentElement]);
  var position = fixed ? "fixed" : "absolute";
  props = useWrapElement(props, function (element) {
    return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({}, wrapperProps), {
      style: __spreadValues({
        // https://floating-ui.com/docs/computeposition#initial-layout
        position: position,
        top: 0,
        left: 0,
        width: "max-content"
      }, wrapperProps == null ? void 0 : wrapperProps.style),
      ref: store == null ? void 0 : store.setPopoverElement,
      children: element
    }));
  }, [store, position, wrapperProps]);
  props = useWrapElement(props, function (element) {
    return /* @__PURE__ */jsx(PopoverScopedContextProvider, {
      value: store,
      children: element
    });
  }, [store]);
  props = __spreadProps(__spreadValues({
    // data-placing is not part of the public API. We're setting this here so
    // we can wait for the popover to be positioned before other components
    // move focus into it. For example, this attribute is observed by the
    // Combobox component with the autoSelect behavior.
    "data-placing": !positioned || void 0
  }, props), {
    style: __spreadValues({
      position: "relative"
    }, props.style)
  });
  props = useDialog(__spreadProps(__spreadValues({
    store: store,
    modal: modal,
    portal: portal,
    preserveTabOrder: preserveTabOrder,
    preserveTabOrderAnchor: disclosureElement || anchorElement,
    autoFocusOnShow: positioned && autoFocusOnShow
  }, props), {
    portalRef: portalRef
  }));
  return props;
});
var Popover = createDialogComponent(forwardRef(function Popover2(props) {
  var htmlProps = usePopover(props);
  return createElement(TagName, htmlProps);
}), usePopoverProviderContext);
export { usePopover, Popover };